import { format } from 'date-fns';
import { fi } from 'date-fns/locale';

export const formatDate = (dateTime: string): string => {
  return format(new Date(dateTime), 'dd.MM.yyyy');
};
export const formatFullDateTime = (timestamp: number, simple?: boolean): string => {
  if (simple) {
    return format(new Date(timestamp), 'dd.MM.yyyy HH:mm');
  }
  const string = `${format(new Date(timestamp), 'iiiiii dd.MM.yyyy', { locale: fi })} klo ${format(new Date(timestamp), 'HH:mm')}`;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const setPriceFormat = (suppliedPriceString: string): string => {
  let formattedPrice: string;

  const price = suppliedPriceString.split('.');
  if (price.length === 2) {
    formattedPrice = `${price[0]},${price[1].length === 1 ? `${price[1]}0` : price[1]}`;
  } else {
    formattedPrice = suppliedPriceString;
  }

  return formattedPrice;
};

export const roundNumber = (providedNumber: number, decimalDots = true, decimals = 2): string => {
  const factor = parseInt(1 + '0'.repeat(decimals));
  const dotString = (Math.round((providedNumber + Number.EPSILON) * factor) / factor).toString();
  if (!decimalDots) {
    return dotString.replace('.', ',');
  }
  return dotString;
};

export const numberToString = (providedNumber: number): string => {
  return providedNumber.toString().replace('.', ',');
};

/**
 * This function gets the correct bank code to use in barcode generation
 *
 * @param contractNo number
 * @param contracts Contrat[]
 * @param endpoint string
 */
export const getCorrectBankAccount = (company: string): string | undefined => {
  let bankCode: string | undefined = '';

  if (company && company.toLowerCase().includes('ekosähkö')) {
    bankCode = import.meta.env.VITE_RET_BANKCODE_LOISTE_ES;
  } else {
    bankCode = import.meta.env.VITE_RET_BANKCODE_LOISTE_SM;
  }

  return bankCode;
};

export const getInvoiceState = (statusCode: number): string => {
  if (statusCode === 1) {
    return 'paid';
  }
  if (statusCode === 2) {
    return 'open';
  }
  if (statusCode === 3) {
    return 'postponed';
  }
  if (statusCode === 4) {
    return 'unpaid';
  }
  if (statusCode === 5) {
    return 'refund';
  }
  return 'unknown';
};

export const getVirtualBarCode = (bankAccount: string, invoiceAmount: number, reference: string, invoiceDue: string): string => {
  const bankCode = bankAccount;
  const version = 4;
  const splitAmount = invoiceAmount.toString().split('.');
  let amount = '';

  // Barcode requires the amount to be between 0 and 999999. It also always needs to be 6 didgets long.
  const amountEuros = splitAmount[0].padStart(6, '0');

  // Barcode requires cent values and they need to be 2 didgets long.
  let amountCents;
  if (!splitAmount[1]) {
    amountCents = splitAmount[1] = '00';
  } else {
    amountCents = splitAmount[1].padEnd(2, '0');
  }
  amount = amountEuros + amountCents;

  if (!reference) {
    reference = '';
  }

  // The reference number needs to be a total of 23 characters long.
  const referenceNumber = reference.padStart(23, '0');
  const dueDate = format(new Date(invoiceDue), 'yyMMdd');

  const code = version + bankCode + amount + referenceNumber + dueDate;

  return code;
};
